import React, {Component} from 'react'
import style from './cta.module.scss';
// Import neccessary site components, try to maintain alphabetical order
import Icon from 'components/icon'
import Link from 'shared/link';

class CTA extends Component {
	render() {
		var title = "Symptoms and Conditions Guide";
		if (this.props.title) {
			title = this.props.title;
		}
		var icon = "medical";
		if (this.props.icon) {
			icon = this.props.icon;
		}
		var link = "/";
		if (this.props.link) {
			link = this.props.link;
		}
		var cta = "Button CTA";
		if (this.props.cta) {
			cta = this.props.cta;
		}
		var description = "Etiam ultricies tortor mattis, mollis lorem eu, rhoncus nunc. Integer vel felis hendrerit, iaculis nisi non, porta massa. Fusce id pharetra urna. Mauris quam risus, eleifend cursus orci a, posuere mollis odio.";
		if (this.props.description) {
			description = this.props.description;
		}
		return(
			<div className={[style.container, "grid-container"].join(' ')}>
				<div className="grid-x">
					<div className={[style.iconHolder, "cell medium-4"].join(' ')}>
						<Icon className={style.icon} icon={icon} />
					</div>
					<div className={[style.content, "cell medium-8"].join(' ')}>
						<h3 className={style.title}>{title}</h3>
						<p>{description}</p>
						<Link className={[style.cta, 'button'].join(' ')} to={link}>{cta}</Link>
					</div>
				</div>
			</div>
		)
	}
}

export default CTA;